export default __webpack_public_path__ + "static/media/banner.994b8684.png";